export enum WebSocketEvent {
  TABLES_PUBLIC_SUBSCRIBE = "tablesPublicSubscribe",
  TABLES_PUBLIC_INIT = "tablesPublicInit",
  TABLES_PUBLIC_UPDATE = "tablesPublicUpdate",

  EXCEPTION = "exception",
}
